export default __webpack_public_path__ + "static/media/image3.78018be1.png";